module.exports = __webpack_public_path__ + "media/760เสียไม่ได้หรือคะ.146cc7e6.mp3";